import React, { useEffect, useState, useRef } from "react";
import { Button } from "primereact/button";
import { TabView, TabPanel } from "primereact/tabview";
import Swal from "sweetalert2";
import { Checkbox } from "primereact/checkbox";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import { Messages } from "primereact/messages";
import _ from "lodash";
import { axiosWithHeaders } from "../../../store/constants/axiosWrapper";
import {
  DEL_CHANNELS,
  ADD_CHANNELS,
  UPDATE_CHANNELS,
} from "../../../store/constants/serviceEndpoint";
import * as enums from "../../../common/enum";

const initData = {
  name: "",
  desc: "",
  isDefault: false,
};

export default function ConfigChanel({ eventId = 0, data = [], onReloadData }) {
  const refNewMessage = useRef(null);
  const refUpdateMessage = useRef(null);

  const [visible, setVisible] = useState(false);
  const [item, setItem] = useState(initData);
  const [loading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState(0);
  const [listChannel, setListChannel] = useState([]);

  useEffect(() => {
    if (_.isArray(data)) {
      const result = data.map((item) => {
        return {
          ...item,
          isModified: false,
          isEdit: true,
        };
      });
      setListChannel(result);
    }
  }, [data]);

  // console.log(listChannel);

  const delChannel = (e, Id) => {
    e.preventDefault();
    // console.log(id);
    Swal.fire({
      title: "Thông báo",
      text: "Bạn có muốn xóa kênh này không ?",
      type: "warning",
      showCancelButton: true,
      //confirmButtonColor: '#3085d6',
      //cancelButtonColor: '#d33',
      confirmButtonText: "Đồng ý!",
      cancelButtonText: "Trở về",
    }).then((result) => {
      if (result.value) {
        setLoading(true);
        axiosWithHeaders("post", DEL_CHANNELS, { Id })
          .then((response) => {
            if (
              response &&
              response.data &&
              response.status === enums.RESPONSE_OK
            ) {
              const { status, message } = response.data;
              if (status === enums.RESPONSE_OK) {
                Swal.fire("Thông báo", "Xoá kênh thành công !", "success");
                if (typeof onReloadData === "function") onReloadData(eventId);
              } else {
                Swal.fire("Lỗi", message, "error");
              }
            }
          })
          .catch((error) => alert(error.toString()))
          .finally(() => {
            setLoading(false);
          });
      }
    });
  };

  const onCancel = (e, isModified, index) => {
    e.preventDefault();
    if (isModified) {
      Swal.fire({
        title: "Thông báo",
        text: "Dữ liệu đã bị chỉnh sửa, bạn có muốn cập nhật không ?",
        type: "warning",
        showCancelButton: true,
        //confirmButtonColor: '#3085d6',
        //cancelButtonColor: '#d33',
        confirmButtonText: "Đồng ý!",
        cancelButtonText: "Trở về",
      }).then((result) => {
        if (result.value) {
          updateChannel(e, index);
        }
      });
      return;
    }
    let list = _.cloneDeep(listChannel);
    list[index].isEdit = false;
    setListChannel(list);
  };

  const addChannel = async (e) => {
    e.preventDefault();

    let objChannel = {};
    let obj = {};
    obj.Name = item.name;
    obj.desc = item.description;

    if (obj.Name === "" || obj.Name === null || obj.Name === undefined) {
      refNewMessage.current.show({
        severity: "error",
        summary: "Lỗi",
        detail: "Vui lòng nhập tên kênh !",
      });
      return;
    }

    if (obj.desc === "" || obj.desc === null || obj.desc === undefined) {
      refNewMessage.current.show({
        severity: "error",
        summary: "Lỗi",
        detail: "Vui lòng nhập mô tả !",
      });
      return;
    }

    obj.EventId = eventId;
    obj.IsDefault = item.isDefault;
    objChannel["NewChannel"] = obj;
    // console.log(objChannel);
    setLoading(true);
    axiosWithHeaders("post", ADD_CHANNELS, objChannel)
      .then((response) => {
        if (
          response &&
          response.data &&
          response.status === enums.RESPONSE_OK
        ) {
          const { status, message } = response.data;
          if (status === enums.RESPONSE_OK) {
            Swal.fire("Thông báo", "Thêm kênh thành công", "success");
            setItem(null);
            setVisible(false);
            if (typeof onReloadData === "function") onReloadData(eventId);
          } else {
            Swal.fire("Lỗi", message, "error");
          }
        }
      })
      .catch((err) => {
        Swal.fire("Lỗi", err.toString(), "error");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const updateChannel = (e, index) => {
    e.preventDefault();
    if (!listChannel[index].isModified) {
      return;
    }

    const objUpdate = {};
    objUpdate.Name = listChannel[index].name;
    objUpdate.Description = listChannel[index].desc;

    if (
      objUpdate.Name === "" ||
      objUpdate.Name === null ||
      objUpdate.Name === undefined
    ) {
      refUpdateMessage.current.show({
        severity: "error",
        summary: "Lỗi",
        detail: "Vui lòng nhập tên kênh !",
      });
      return;
    }

    if (
      objUpdate.Description === "" ||
      objUpdate.Description === null ||
      objUpdate.Description === undefined
    ) {
      refUpdateMessage.current.show({
        severity: "error",
        summary: "Lỗi",
        detail: "Vui lòng nhập mô tả !",
      });
      return;
    }

    objUpdate.EventId = eventId;
    objUpdate.IsDefault = listChannel[index].isDefault;
    objUpdate.Id = listChannel[index].id;
    // console.log(objUpdate);
    setLoading(true);
    axiosWithHeaders("post", UPDATE_CHANNELS, objUpdate)
      .then((response) => {
        if (
          response &&
          response.data &&
          response.status === enums.RESPONSE_OK
        ) {
          const { status, message } = response.data;
          if (status === enums.RESPONSE_OK) {
            Swal.fire("Thông báo", "Cập nhật thành công", "success");
            setItem(null);
            setVisible(false);
            if (typeof onReloadData === "function") onReloadData(eventId);
          } else {
            Swal.fire("Lỗi", message, "error");
          }
        }
      })
      .catch((err) => {
        Swal.fire("Lỗi", err.toString(), "error");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const renderContentTab = () => {
    let html = [];
    listChannel.forEach((channel, i) => {
      html.push(
        <TabPanel header={channel.name} key={i}>
          <div className="row mt-2" style={{ minHeight: 35 }}>
            <div className="col-md-2 text-right align-self-center">
              <label htmlFor={`txt-${channel.id}`}>Kênh</label>
            </div>
            <div className="col-md-8 align-self-center">
              <InputText
                id={`txt-${channel.id}`}
                style={{ width: "100%" }}
                placeholder="Nhập tên kênh..."
                value={channel.name}
                onChange={(e) => {
                  e.preventDefault();
                  let list = _.cloneDeep(listChannel);
                  list[i].name = e.target.value;
                  list[i].isModified = true;
                  setListChannel(list);
                }}
                disabled={channel.isEdit}
              />
            </div>
          </div>
          <div className="row mt-2" style={{ minHeight: 35 }}>
            <div className="col-md-2 text-right align-self-start">
              <label>Mô tả</label>
            </div>
            <div className="col-md-8 align-self-center">
              <InputTextarea
                rows={5}
                style={{ width: "100%" }}
                value={channel.desc}
                placeholder="Nhập mô tả về hoạt động..."
                onChange={(e) => {
                  e.preventDefault();
                  let list = _.cloneDeep(listChannel);
                  list[i].desc = e.target.value;
                  list[i].isModified = true;
                  setListChannel(list);
                }}
                disabled={channel.isEdit}
              />
            </div>
          </div>
          <div className="row mt-2" style={{ minHeight: 35 }}>
            <div className="col-md-2 text-right align-self-start"></div>
            <div className="col-md-8 align-self-center">
              <Checkbox
                checked={channel.isDefault}
                inputId={`chk-${channel.id}`}
                onChange={(e) => {
                  let list = _.cloneDeep(listChannel);
                  list[i].isDefault = e.checked;
                  list[i].isModified = true;
                  setListChannel(list);
                }}
                disabled={channel.isEdit}
              ></Checkbox>
              <label htmlFor={`chk-${channel.id}`} className="p-checkbox-label">
                &nbsp;Mặc định
              </label>
            </div>
          </div>
          <div className="row mt-2" style={{ minHeight: 35 }}>
            {channel.isEdit ? (
              <div className="col-md-12 text-center">
                <Button
                  label="SỬA"
                  icon="pi pi-pencil"
                  className="p-button-raised p-button-secondary"
                  onClick={(e) => {
                    e.preventDefault();
                    let list = _.cloneDeep(listChannel);
                    list[i].isEdit = false;
                    // list[i].isUpdate = true;
                    setListChannel(list);
                  }}
                />
              </div>
            ) : (
              <div className="col-md-12 text-center">
                <Button
                  label="HỦY"
                  icon="pi pi-times"
                  className="p-button-raised p-button-secondary"
                  onClick={(e) => onCancel(e, channel.isModified, i)}
                  style={{ marginRight: 10 }}
                  loading={loading}
                />

                <Button
                  label="XÓA"
                  icon="pi pi-trash"
                  className="p-button-raised p-button-danger"
                  onClick={(e) => delChannel(e, channel.id)}
                  style={{ marginRight: 10 }}
                  loading={loading}
                />

                <Button
                  label="CẬP NHẬT"
                  icon="pi pi-pencil"
                  className="p-button-raised p-button-success"
                  onClick={(e) => updateChannel(e, i)}
                />
              </div>
            )}
          </div>
        </TabPanel>
      );
    });
    return html;
  };

  const renderTab = () => {
    if (listChannel.length > 0) {
      return (
        <>
          <div className="row mt-3">
            <div className="col-md-12">
              <Messages ref={refUpdateMessage}></Messages>
            </div>
          </div>
          <div className="row mt-3">
            <div className="col-md-12">
              <TabView
                activeIndex={activeTab}
                onTabChange={(e) => setActiveTab(e.index)}
              >
                {renderContentTab()}
              </TabView>
            </div>
          </div>
        </>
      );
    }
    return (
      <div className="row mt-3">
        <div className="col-md-12">
          Kênh chưa được tạo trên event này. Vui lòng bấm thêm để tạo kênh
          mới...
        </div>
      </div>
    );
  };

  const footer = (
    <>
      <Button
        loading={loading}
        label="Xác nhận"
        icon="pi pi-check"
        onClick={(e) => addChannel(e)}
        className="p-button-raised p-button-info"
      />
      <Button
        loading={loading}
        label="Hủy"
        className="p-button-raised p-button-secondary"
        icon="pi pi-times"
        onClick={() => {
          setVisible(false);
          setItem(initData);
        }}
      />
    </>
  );

  return (
    <>
      <div className="row">
        <div
          className={`col-md-12 d-flex align-items-center position-relative justify-content-between`}
        >
          <div style={{ minWidth: 100 }}></div>
          <div style={{ fontSize: `1.5rem`, color: `red`, fontWeight: 700 }}>
            CÀI ĐẶT KÊNH
          </div>
          <div>
            <Button
              label="THÊM"
              icon="pi pi-plus"
              className="p-button-raised p-button-secondary"
              onClick={() => {
                setVisible(true);
                setItem(initData);
              }}
            />
          </div>
        </div>
      </div>
      {renderTab()}
      <Dialog
        header="Thêm kênh"
        footer={footer}
        visible={visible}
        style={{ width: 500 }}
        modal={true}
        onHide={() => setVisible(false)}
      >
        <div className="row mt-2">
          <div className="col-md-12">
            <Messages ref={refNewMessage}></Messages>
          </div>
        </div>
        <div className="row mt-2">
          <div className="col-md-2 align-self-center text-right">
            <label htmlFor="lblName">Kênh</label>
          </div>
          <div className="col-md-10">
            <InputText
              id="lblName"
              style={{ width: "100%" }}
              placeholder="Nhập tên kênh..."
              onChange={(e) => setItem({ ...item, name: e.target.value })}
              // value={this.state.name}
              value={item && item.name ? item.name : ""}
            />
          </div>
        </div>

        <div className="row mt-2">
          <div className="col-md-2 align-self-center text-right">
            <label htmlFor="lblDescription">Mô tả</label>
          </div>
          <div className="col-md-10">
            <InputTextarea
              id="lblDescription"
              rows={5}
              style={{ width: "100%" }}
              value={item && item.description ? item.description : ""}
              onChange={(e) =>
                setItem({ ...item, description: e.target.value })
              }
              placeholder="Nhập mô tả về hoạt động..."
            />
          </div>
        </div>

        <div className="row mt-2">
          <div className="col-md-2 align-self-center text-right"></div>
          <div className="col-md-10">
            <Checkbox
              checked={item && item.isDefault ? item.isDefault : false}
              inputId={`chk-add`}
              onChange={(e) => {
                setItem({
                  ...item,
                  isDefault: e.checked,
                });
              }}
            ></Checkbox>
            <label htmlFor={`chk-add`} className="p-checkbox-label">
              &nbsp;Mặc định
            </label>
          </div>
        </div>
      </Dialog>
    </>
  );
}
